<template>
    <div class="mb-2">
        <modal name="preview"
               classes="preview"
               transition="scale"
               :height="'100%'"
               :width="'100%'">
            <div style="width: 100%; height: 100%" @click="closeModal">
                <img :src="previewImage" />
            </div>
        </modal>

        <ul class="product--base-info is--width list--unstyled" :class="['is--grooves-' + grooves.value, { 'is--disabled': disabled }]">
            <li class="base-info--entry"
                v-for="item in collection"
                :class="{ selected: value === item }"
                @click="input(item)">
                <span :class="'is--width-' + item.value">
                    <img :src="'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/' + colorClass + '/' + item.value + '-' + grooves.value + '.png'"
                         :style="{width: item.value + 'px', display: 'inline-block'}" alt="">
                </span>
                <span class="">{{ item.label }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import EventBus from '../../../event-bus';
    import { gtag_event } from "../../../gtag";

    export default {
        data() {
            return {
                label: App.configuration.variants.widths.label,
                collection: App.configuration.variants.widths.elements,
                previewImage: ''
            };
        },

        props: {
            value: Object,
            disabled: Boolean,
            color: Object,
            grooves: Object,
        },

        computed: {
            colorClass() {
                if ('none' === this.color.class || 'cake-topper' === this.color.class) {
                    return App.configuration.variants.colors.elements[0].class;
                }

                return this.color.class;
            }
        },

        methods: {
            openPreview(image) {
                this.previewImage = image.source;
                this.$modal.show('preview');
            },

            closeModal() {
                let vm = this;

                vm.$modal.hide('preview');

                window.setTimeout(() => {
                    vm.previewImage = '';
                }, 100);
            },

            input(item) {
                if (this.disabled) {
                    return;
                }

                switch (item.value) {
                    case 100:
                        gtag_event('Button Sockel 10cm', 10);
                        break;

                    case 150:
                        gtag_event('Button Sockel 15cm', 15);
                        break;

                    case 200:
                        gtag_event('Button Sockel 20cm', 20);
                        break;

                    case 250:
                        gtag_event('Button Sockel 25cm', 25);
                        break;

                    case 300:
                        gtag_event('Button Sockel 30cm', 30);
                        break;
                }

                if (this.value === item) {
                    this.openPreview({
                         source: '/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/' + this.color.class + '/' + item.value + '-' + this.grooves.value + '.png'
                     });

                    return;
                }

                EventBus.$emit('widthChanged', item);
                this.$emit('input', item);
            },

            colorChanged(item) {
                if ('none' !== item.class) {
                    return;
                }
                if ("cake-topper" !== item.class) {
                    return;
                }

                this.input(this.collection[0]);
            }
        },

        mounted() {
            EventBus.$on('colorChanged', this.colorChanged);
        },

        beforeDestroy() {
            EventBus.$off('colorChanged', this.colorChanged);
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/scss/components/base";
</style>



// WEBPACK FOOTER //
// src/components/Base/Desktop/Width.vue